import { Box, CloseRoundedIcon, styledComponent, Dialog } from '@hermes/web-components'

export const StyledCloseIcon = styledComponent(CloseRoundedIcon)(() => ({
  color: '#6F7F9E',
  cursor: 'pointer',
  borderRadius: '50%',
  width: '34px',
  height: '34px',
  padding: '4px',
  boxShadow: '0px 0px 7px 0px rgba(0, 0, 0, 0.10)'
}))

export const StyledContainer = styledComponent(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '16px',
  width: '100%',
  paddingTop: '82px', // header offset
  paddingInline: '16px',
  overflowX: 'hidden',

  [theme.breakpoints.down('sm')]: {
    paddingTop: '22px'
  }
}))

export const FullScreenDialog = styledComponent(Dialog)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '& .MuiDialog-container': {
    width: '100%'
  },

  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',

    '& .MuiDialog-paper': {
      width: '100%',
      maxHeight: 'none',
      borderRadius: '16px 16px 0px 0px',
      bottom: 0,
      left: 0,
      marginTop: '5vh !important',
      height: '95vh !important'
    },

    '& .MuiDialogContent-root': {
      width: '100%',
      padding: '24px 8px 24px 24px',
      overflow: 'hidden'
    }
  }
}))
